import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import ErrorAlert from "./ErrorAlert";
import Tooltip from "./Tooltip";

const TextInput = (props) => {
  const { t } = props;
  if (props.render) {
    return (
      <div
        className={"form-group " + (props.error ? "not-valid" : "")}
        style={{ position: "relative" }}
      >
        <label className="input-label"></label>
        <input
          type={props.type}
          name={props.name}
          className="form-control"
          placeholder={t(props.label)}
          value={props.value}
          maxLength={props.maxLength ? props.maxLength : "50"}
          onChange={props.handleChange}
          onBlur={props.handleBlur}
        />
        {props.tooltip && (
          <i
            data-tip={t(props.tooltip)}
            data-for={props.tooltip ? props.name : ""}
            ref={(ref) => (props.toolTipRef = ref)}
            data-offset="{'bottom': 5, 'left': 0, 'right':-56}"
            data-place="bottom"
            className={
              "fa fa-question-circle" +
              (window.lang !== "en" ? " fa-flip-horizontal" : "")
            }
            aria-hidden="true"
            onClick={() => {
              ReactTooltip.show(props.toolTipRef);
            }}
            style={{
              position: "absolute",
              "z-index": "999",
              right: window.lang === "en" ? "0" : null,
              left: window.lang !== "en" ? "0" : null,
              bottom: "0.5rem",
              
            }}
          ></i>
        )}

      {props.hint && <small>{t(props.hint)}</small>}
      {props.error && <ErrorAlert error={props.error} />}
        {props.tooltip && (
          <Tooltip id={props.name} tooltipBody={props.tooltip} />
        )}
      </div>
    );
  } else {
    return null;
  }
};

TextInput.propTypes = {
  render: PropTypes.bool.isRequired,
};

export default withTranslation()(TextInput);
